'use es6';
/*
 * CodeMirror options universal to all instances in the application.
 */

import SeamlessImmutable from 'seamless-immutable';
import Settings from 'react-codemirror/model/Settings';
import { CODEMIRROR_OPTIONS_FETCH, CODEMIRROR_OPTIONS_UPDATE, RECEIVE_ATTRIBUTES_META } from 'DesignData/actions/ActionTypes';
const DEFAULT_SETTINGS = SeamlessImmutable(Object.assign({}, new Settings()));
export default function (state = DEFAULT_SETTINGS, action) {
  switch (action.type) {
    case RECEIVE_ATTRIBUTES_META:
      {
        if (!action.reactCodeMirrorSettings) {
          return state;
        }

        return SeamlessImmutable.merge(state, action.reactCodeMirrorSettings, {
          deep: true
        });
      }

    case CODEMIRROR_OPTIONS_FETCH:
    case CODEMIRROR_OPTIONS_UPDATE:
      {
        if (!action.options) {
          return state;
        }

        return SeamlessImmutable.merge(state, action.options, {
          deep: true
        });
      }

    default:
      return state;
  }
}